import http from 'conversations-http/clients/http';
const CHANNEL_INSTANCE_PREFIX = 'conversations-channels/v1/channel-instances';
export const fetchChannelInstance = ({
  channelInstanceId
}) => http.get(`${CHANNEL_INSTANCE_PREFIX}/${channelInstanceId}`);
export const fetchChannelInstances = ({
  channelInstanceIds
}) => http.get(`${CHANNEL_INSTANCE_PREFIX}/batch`, {
  query: {
    channelInstanceIds
  }
});